<template>
  <h2 class="heading-xs mb-24">{{ heading }}</h2>
  <AppAccordion
    v-for="(qa, index) in data"
    :key="qa.q?.replaceAll(' ', '')"
    :is-open="openAccordion === index.toString()"
    :base-html-id="`${index}`"
    :show-border-top="index === 0"
    :only-mobile="false"
    border-color="secondary"
    @on-toggle="closeAllOther($event.isOpen, $event.id)"
  >
    <template #header>
      <p class="heading-xxs">{{ qa.q }}</p>
    </template>
    <p
      class="pb-32 max-w-600"
      v-html="markup_markdownLikeTextToHtmlString(qa.a)"
    ></p>
  </AppAccordion>
</template>

<script lang="ts" setup>
import { markup_markdownLikeTextToHtmlString } from '~/utils/markup/allTextTransformations';

export type FaqQA = {
  q: string;
  a: string;
};

interface Props {
  heading?: string;
  data: FaqQA[];
}

const openAccordion: Ref<string> = ref('');

const closeAllOther = async (isOpen: boolean, id: string) => {
  if (isOpen) {
    openAccordion.value = id;
  }
};

defineProps<Props>();
</script>

<style></style>
